import timesheetApi from "api/timesheet";
import { Button, Col, Form, Modal, Row, Select, Spin } from "antd";
import { useEffect, useState, useMemo } from "react";
import moment from "moment";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";

export default function ModalTimeSheetUser({
    openModal,
    setOpenModal,
    id,
    setId,
    openNotificationWithIcon
}) {

    const { t } = useTranslation()

    const [detailTimeSheet, setDetailTimeSheet] = useState();
    const [loading, setLoading] = useState(false)

    const AbsenceList = useMemo(() => {
        if (detailTimeSheet?.absence?.data) {
            const data = detailTimeSheet?.absence?.data.sort((a, b) => new Date(a) - new Date(b));

            const result = data.reduce((currentValue, nextValue) => {
                if (isEmpty(currentValue)) {
                    currentValue.push([nextValue]);

                    return currentValue;
                }

                const lastArrDate = currentValue[currentValue.length - 1]

                const dateLast = moment(lastArrDate[lastArrDate.length - 1]).add(1, 'days').format("DD-MM-YYYY");
                const dateNext = moment(nextValue).format("DD-MM-YYYY");

                if (dateLast === dateNext) {
                    lastArrDate.push(nextValue)
                } else {
                    currentValue.push([nextValue])
                }

                return currentValue;
            }, []).map((item) => {
                const itemResult = {};

                if (item.length > 1) {
                    itemResult.total = item.length;
                    itemResult.date = `${moment(item[0]).format('DD/MM/YYYY')} - ${moment(item[item.length - 1]).format('DD/MM/YYYY')}`;
                } else {
                    itemResult.total = 1;
                    itemResult.date = moment(item[0]).format('DD/MM/YYYY');
                }
                itemResult.isLastYear = moment(item[0]).format('YYYY') !== moment().format('YYYY');

                return itemResult;
            })

            return result;
        }

        return [];

    }, [detailTimeSheet])

    const sickList = useMemo(() => {
        if (detailTimeSheet?.sick?.data) {
            const data = detailTimeSheet?.sick?.data.sort((a, b) => new Date(a) - new Date(b));

            const result = data.reduce((currentValue, nextValue) => {
                if (isEmpty(currentValue)) {
                    currentValue.push([nextValue]);

                    return currentValue;
                }

                const lastArrDate = currentValue[currentValue.length - 1]

                const dateLast = moment(lastArrDate[lastArrDate.length - 1]).add(1, 'days').format("DD-MM-YYYY");
                const dateNext = moment(nextValue).format("DD-MM-YYYY");

                if (dateLast === dateNext) {
                    lastArrDate.push(nextValue)
                } else {
                    currentValue.push([nextValue])
                }

                return currentValue;
            }, []).map((item) => {
                const itemResult = {};

                if (item.length > 1) {
                    itemResult.total = item.length;
                    itemResult.date = `${moment(item[0]).format('DD/MM/YYYY')} - ${moment(item[item.length - 1]).format('DD/MM/YYYY')}`;
                } else {
                    itemResult.total = 1;
                    itemResult.date = moment(item[0]).format('DD/MM/YYYY');
                }
                itemResult.isLastYear = moment(item[0]).format('YYYY') !== moment().format('YYYY');

                return itemResult;
            })

            return result;
        }

        return [];
    }, [detailTimeSheet])

    const onCancel = () => {
        setOpenModal(false);
        setId(null);
    }

    const handleGetDetailTimeSheet = async (id) => {
        try {
            setLoading(true)
            const res = await timesheetApi.getDetailTimeSheet(id);

            if (res.success) {
                setDetailTimeSheet(res.data);
            }
        } catch (error) {
            openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (id && openModal) {
            handleGetDetailTimeSheet(id)
        }
    }, [openModal])

    return (
        <Modal
            title={`${t('fullName')}: ${detailTimeSheet?.name}`}
            centered
            open={openModal}
            footer={null}
            onCancel={onCancel}
            width={400}
            destroyOnClose

        >
            <Spin spinning={loading}>
                <p>{t('remaingLastYearAbsence')}: {+detailTimeSheet?.lastYearNumAbsence}</p>
                <p>{t('thisYearAbsence')}: {detailTimeSheet?.numAbsence}</p>
                <p>{t('totalAbscene')}: {detailTimeSheet?.numAbsence + +detailTimeSheet?.lastYearNumAbsence}</p>
                <p>{t('remainingAbsence')}: {detailTimeSheet?.numAbsence + +detailTimeSheet?.lastYearNumAbsence - detailTimeSheet?.absence.total}</p>
                <p>{t('workStartDate')}: {moment(detailTimeSheet?.createdAt).format('YYYY-MM-DD')}</p>
                <p>{t('year')}: {moment().format('YYYY')}</p>
                <div style={{ display: "flex" }}><p style={{ width: "200px" }}>{t('numOfAbsence')}</p>: {detailTimeSheet?.absence.total}/{detailTimeSheet?.numAbsence + +detailTimeSheet?.lastYearNumAbsence}</div>
                {AbsenceList.filter(item => !item.isLastYear).map((item, index) => {
                    return <div style={{ display: "flex" }} key={index}><p style={{ width: "200px" }}>{item.date}</p>: {item.total}</div>
                })}
                <div style={{ display: "flex" }}><p style={{ width: "200px" }}>{t('numOfSick')}</p>: {detailTimeSheet?.sick.total}</div>
                {/* {sickList.filter(item => !item.isLastYear).map((item, index) => {
                    return <div style={{ display: "flex" }} key={index}><p style={{ width: "200px" }}>{item.date}</p>: {item.total}</div>
                })} */}
            </Spin>
        </Modal>
    )
}